package gr.tech.pdfgenerator.util

import androidx.compose.runtime.mutableStateMapOf
import androidx.compose.runtime.mutableStateOf
import kotlinx.browser.window
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.await
import kotlinx.coroutines.launch
import kotlinx.serialization.Serializable

@Serializable
data class AvgRate(
    val stateAbb: String = "",
    val stateName: String = "",
    val rebateRate: Double = 0.00,
    val country: String = ""
)

class StateAppendix(pathToCSV: String, scope: CoroutineScope) {
    val rates = mutableStateMapOf<String, AvgRate>()
    var isDataLoaded = mutableStateOf(false)

    init {
        readUtilitiesCSV(pathToCSV, scope)
    }

    fun listOfStates(): List<String> {
        return rates.keys.sorted().toList()
    }

    fun getStateInfo(key: String): AvgRate? {
        return rates[key]
    }

    // Reading CSV synchronously (via fetch for browser-based code)
    private fun readUtilitiesCSV(filename: String, scope: CoroutineScope) {
        // Use a coroutine to fetch the CSV file (since fetch is asynchronous)
        scope.launch {
            try {
                val response = window.fetch(filename).await()
                if (response.ok) {
                    val fileContent = response.text().await()  // Get the content of the CSV
                    processCSV(fileContent)  // Process the CSV content
                } else {
                    console.error("Failed to load CSV file: $filename")
                }
            } catch (e: Throwable) {
                console.error("Error loading CSV file: $filename | $e")
            }
        }
    }

    private fun processCSV(csvContent: String) {
        val lines = csvContent.split("\n")
        lines.drop(1).forEach { line ->
            val parts = line.split(",")
            val stateAbbrev = parts[0].trim()
            val stateName = parts[1].trim()
            val rebateRate = parts[2].trim().toDouble()
            val country = parts[3].trim()

            val rateRow = AvgRate(stateAbbrev, stateName, rebateRate, country)
            rates[stateAbbrev] = rateRow
        }
        isDataLoaded.value = true
    }
}


